import { Outlet, Navigate } from "react-router-dom";
import { useStore } from "../Context/StoreContext";

const ProtectedRoutes = () => {
  const { user } = useStore();
  return user ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
